import { StandardEvents } from '@shopify/events';
  let studioNoticeTimer;
  document.addEventListener(StandardEvents.cartLinesUpdate, (event) => {
    event.promise?.then(({ cart, detail }) => {
      const count = cart?.totalQuantity ?? detail?.itemCount ?? 0;
      document.querySelectorAll('[data-studio-bag]').forEach((bag) => {
        const badge = bag.querySelector('.studio-bag-count');
        badge.textContent = String(count);
        badge.hidden = count === 0;
        bag.querySelector('.studio-bag-arrow').hidden = count > 0;
        bag.setAttribute('aria-label', bag.dataset.countLabel.replace('__COUNT__', String(count)));
      });
      const notice = document.querySelector('.studio-cart-notice');
      if (event.action === 'add' && !detail?.didError && notice) {
        notice.hidden = false;
        clearTimeout(studioNoticeTimer);
        studioNoticeTimer = setTimeout(() => { notice.hidden = true; }, 7000);
      }
    }).catch(() => {});
  });
  document.addEventListener('click', (event) => {
    const dismiss = event.target.closest('.studio-cart-notice button');
    if (dismiss) dismiss.closest('.studio-cart-notice').hidden = true;
  });
  document.addEventListener('click', (event) => {
    document.querySelectorAll('.studio-mega[open], .studio-mobile-nav[open]').forEach((menu) => {
      if (!menu.contains(event.target)) menu.open = false;
    });
  });
  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') return;
    document.querySelectorAll('.studio-mega[open], .studio-mobile-nav[open]').forEach((menu) => {
      menu.open = false;
      menu.querySelector('summary').focus();
    });
  });
